import { Mail, Sparkles } from "lucide-react";
import { Button } from "../components/ui/button";
import SEO from "../components/SEO";

export default function AboutPage() {
  return (
    <div className="min-h-screen pt-20 bg-gradient-to-b from-pink-50 to-white" data-testid="about-page">
      <SEO 
        title="About Us"
        description="Cotton Candy Girl Co. is a wholesale cotton candy company serving Las Vegas and Boise—and the creator of the original UV-reactive cotton candy."
        keywords="Cotton Candy Girl, wholesale cotton candy, UV-reactive cotton candy, Las Vegas cotton candy, Boise cotton candy"
        canonical="/about"
      />
      
      {/* Hero */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <span className="inline-block bg-[#FF9EAA] text-white text-sm font-bold px-4 py-2 rounded-full mb-6">
            ABOUT US
          </span>
          <h1 className="text-4xl md:text-5xl font-bold text-[#4A4A4A] mb-8">
            About <span className="gradient-text">Cotton Candy Girl</span>
          </h1>
          
          {/* Bio Card */}
          <div className="bg-white rounded-3xl shadow-lg p-8 md:p-12 text-left">
            <div className="w-16 h-16 rounded-2xl bg-[#FF9EAA] flex items-center justify-center mx-auto mb-8">
              <Sparkles className="text-white" size={32} />
            </div>
            
            <p className="text-lg md:text-xl text-[#4A4A4A] leading-relaxed mb-6">
              Cotton Candy Girl Co. is a wholesale cotton candy company serving Las Vegas and Boise—and the creator of the original UV-reactive cotton candy.
            </p>
            
            <p className="text-lg md:text-xl text-[#888888] leading-relaxed">
              We partner with retailers, resorts, entertainment venues, and specialty shops to create fresh, shelf-ready products featuring flexible packaging, private-label branding, and our non-toxic, naturally UV-activated Birthday Cake cotton candy.
            </p>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mx-auto text-center">
          <div className="bg-gradient-to-br from-pink-50 to-purple-50 rounded-3xl p-8 md:p-12">
            <h2 className="text-2xl md:text-3xl font-bold text-[#4A4A4A] mb-4">Get In Touch</h2>
            <p className="text-[#888888] mb-6">Interested in partnering with us? Contact us for wholesale pricing and availability.</p>
            
            <a 
              href="mailto:shea@cottoncandygirl.co"
              className="inline-flex items-center gap-3 text-xl md:text-2xl font-bold text-[#FF9EAA] hover:text-[#FF8FAB] transition-colors mb-6"
            >
              <Mail size={28} />
              shea@cottoncandygirl.co
            </a>
            
            <div className="mt-6">
              <a href="mailto:shea@cottoncandygirl.co">
                <Button 
                  className="bg-[#FF9EAA] hover:bg-[#FF8FAB] text-white rounded-full px-8 py-6 text-lg font-semibold shadow-lg hover:shadow-xl transition-all btn-scale"
                  data-testid="contact-btn"
                >
                  <Mail className="mr-2" size={20} />
                  Contact Us
                </Button>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
